// extracted by mini-css-extract-plugin
export var root = "AboutUs-module--root--3FijC";
export var content = "AboutUs-module--content--1HsFa";
export var title = "AboutUs-module--title--1rmRY";
export var highlight = "AboutUs-module--highlight--24Kcq";
export var doctor = "AboutUs-module--doctor--2DG6o";
export var description = "AboutUs-module--description--3LdEx";
export var teamPhoto = "AboutUs-module--teamPhoto--2OC4Z";
export var image = "AboutUs-module--image--1glQt";